import {
  Text,
} from '@chakra-ui/react';
import {
  useLengthVsVKT,
} from '@src/modules/performance/context/reports-api-hooks';
import TornadoBarChart from '@src/modules/performance/components/charts/TornadoBarChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Journey Distribution - ONF General Traffic',
  content: [
    {
      title: 'Length vs VKT (ONF General Traffic)',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The distribution of vehicle kilometres travelled and network length for the financial year, summarised by ONF General Traffic classifications.
    </Text>
    <Text fontSize="inherit" mb={2}>
      Road Efficiency Group Te Ringa Maimoa has calculated this result.
    </Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from the ONF classifications and traffic volumes recorded in AWM.
  </Text>,
    },
  ],
};

function RoadNetworkUseJourneyDistributionGeneralTraffic() {
  const { data: lengthVsVktGeneralTraffic, isLoading: isLoadingLengthGeneralTraffic } = useLengthVsVKT('generalTraffic');
  const isLoading = isLoadingLengthGeneralTraffic;

  // General Traffic Chart
  const lengthVsVktGeneralTrafficData = [
    {
      name: 'Length %',
      type: 'bar',
      data: lengthVsVktGeneralTraffic?.map((item) => ({
        x: item.Category,
        y: item.PercTotalKm > 0.5 ? item.PercTotalKm * -1 : 0,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'Vehicle kilometres travelled %',
      type: 'bar',
      data: lengthVsVktGeneralTraffic?.map((item) => ({
        x: item.Category,
        y: item.PercTotalVKT > 0.5 ? item.PercTotalVKT : 0,
      })),
      color: CHART_COLOURS.red,
    },
  ];

  return (
    <ReportSection
      title="Journey Distribution - ONF General Traffic"
      isLoading={isLoading || !lengthVsVktGeneralTraffic}
      informationSource={informationSource}
      lockYear={lengthVsVktGeneralTraffic?.[0]?.LockYear}
    >
      <TornadoBarChart
        title="Length vs VKT (ONF General Traffic)"
        categories={[...new Set(lengthVsVktGeneralTraffic?.map((item) => item.Category))]}
        series={lengthVsVktGeneralTrafficData}
        dataLabelFormatter={(val) => {
          if (val === 0) {
            return '';
          }
          const labelFormatted = val > 0 ? `${val.toFixed(0)}%` : `${Math.abs(val).toFixed(0)}%`;
          return labelFormatted;
        }}
        suffix="%"
      />
    </ReportSection>
  );
}

export default RoadNetworkUseJourneyDistributionGeneralTraffic;
